<modal [loader]="loader" #modal>

  <b header class="uppercase">{{title}}</b>

  <div class="body">

    <div class="input" *ngIf="!submitted">
      <input type="text" placeholder="{{mailRequest.Receivers.length > 0 ? 'Thêm địa chỉ email' : 'Nhập địa chỉ email cách nhau bằng'}}" (focus)="reset()" (keyup)="update($event)">      
      <span *ngIf="error" class="text-danger">{{error}}</span>
      <div class="email" *ngIf="mailRequest.Receivers.length > 0">
        <div class="uppercase">Các địa chỉ nhận email</div>
        <span *ngFor="let i of mailRequest.Receivers"><i class="fa fa-times text-danger pointer" (click)="remove(i)"></i><b>{{i}}</b></span>
      </div>
      <span *ngIf="!submitable"><small>có thể nhập nhiều địa chỉ email theo cú pháp:</small><br/>email1 <b class="text-black">,</b> email2</span>
    </div>

    <div class="info" *ngIf="submitted">

      <div *ngIf="succeed" class="text-center">        
        <div class="email">
          <div class="uppercase">Thư đã được gửi đến:</div>
          <span *ngFor="let i of mailRequest.Receivers"><i class="fa fa-check text-success"></i><b>{{i}}</b></span>
        </div>
      </div>

      <div *ngIf="!succeed" class="text-warning uppercase"><i class="fad fa-exclamation-circle"></i>Không gửi được thư, xin vui lòng thử lại.</div>

    </div>

    <div class="footer" [hidden]="!submitable">

      <button *ngIf="!submitted" class="bg-success text-white" (click)="send()">
        <i class="far fa-envelope"></i>
        <span>Gửi thư</span>
      </button>

      <button *ngIf="submitted && !succeed" class="bg-success text-white" (click)="retry()">
        <i class="far fa-envelope"></i>
        <span>Gửi lại</span>
      </button>

      <button *ngIf="submitted && succeed" class="bg-primary text-white" (click)="close()">
        <i class="far fa-times"></i>
        <span>Đóng</span>
      </button>
    </div>

  </div>

</modal>
